import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const containerLoading = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  margin-top: -20px;
`;

export const header = css`
  margin: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  & > *:not(:first-child) {
    margin-left: 20px;
  }

  &:after {
    content: "";
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: ${colors.gray.light};
  }
`;

export const tooltipLabel = {
  root: {
    cursor: 'pointer',
    fontWeight: fonts.weight.bold,
    color: colors.primary.default,

    '&:hover': {
      color: colors.primary.hover,
    },
  },
};

export const subheader = css`
  margin: 0 20px;
`;

export const hintStyles = {
  tooltip: {
    maxWidth: 'unset',
  },
  tooltipPlacementBottom: {
    margin: '0 0 0 20px',
    top: -10,
    left: -20,
  },
};

export const hintButtonWrapper = css`
  display: inline-block;
  cursor: not-allowed !important;

  .MuiButtonBase-root.Mui-disabled {
    pointer-events: none !important;
  }
`;

export const hintTitle = css`
  > span {
    font-weight: 400 !important;
    font-size: 12px;
  }
`;

export const filters = css`
  margin: 20px 20px 10px;
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;

  > span {
    max-width: 300px;
  }
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const placeholderWithTextButton = css`
  ${placeholder} margin-bottom: 60px;
`;

export const button = css`
  width: 200px;

  && {
    margin-right: 20px;
  }
`;

export const inputSection = css`
  display: flex;
  justify-content: space-between;
`;
